export class ElementHtml {
  public static TABLE = 'table';  // public static HR = '______________';
  public static HR = '<hr class="class-1" style="width: 120px!important;">';
  public static TEXT = 'text';
  public static TH = 'th';
  public static TD = 'td';
  public static IMAGE = 'image';
  public static IMG = 'img';
  public static _HR = 'hr';
  public static NONE = 'none';
  public static readonly TYPE_TEXT = 1;
  public static readonly TYPE_PARAM = 2;
  public static readonly TYPE_TABLE = 3;
  public static readonly TYPE_IMG = 4;
  public static readonly TYPE_LINE = 5;
  public static readonly TEXT_DESCRIPTION = 'Ingrese texto';
  public static readonly PARAM_DESCRIPTION = 'param';
  public static readonly NONE_DESCRIPTION = '';

  public static getImgElementBy(index: number) {
    return '<img id="image' + index + '" src="../../../../../assets/image/image-default.jpg" alt="" style="object-fit: contain!important; width: 120px!important; height: 100px!important;"/>';
  }
}
